export const programOptions = [
  { value: "ug", label: "Undergraduate" },
  { value: "pg", label: "Postgraduate" },
  { value: "idddp", label: "Inter-Disciplinary Dual Degree" },
];

export const degreeOptions = [
  { value: "BTECH", label: "Bachelor of Technology" },
  { value: "FYBS", label: "Four Year B.S." },
  { value: "MTECH", label: "Master of Technology" },
  { value: "DD", label: "B.Tech. + M.Tech. Dual Degree" },
  { value: "MSC", label: "Master of Science" },
  { value: "PHD", label: "Doctor of Philosophy" },
  { value: "BDES", label: "Bachelor of Design" },
  { value: "MDES", label: "Master of Design" },
  { value: "MPHIL", label: "Master of Philosophy" },
  { value: "MMG", label: "Master of Management" },
  { value: "MSEx", label: "M.S. (Exit Degree)" },
  { value: "MtechEx", label: "Master of Technology (Exit Degree)" },
  { value: "MtechPhDDD", label: "M.Tech. + Ph.D. Dual Degree" },
  { value: "PC", label: "Preparatory Course" },
  { value: "VS", label: "Visiting Student" },
  { value: "MPhilEx", label: "Master of Philosophy (Exit Degree)" },
  { value: "MScEx", label: "Master of Science (Exit Degree)" },
  { value: "MScMTechDD", label: "M.Sc. + M.Tech. Dual Degree" },
  { value: "MScPhDDD", label: "M.Sc. + Ph.D. Dual Degree" },
  { value: "MPhilPhDDD", label: "M.Phil. + Ph.D. Dual Degree" },
  { value: "EMBA", label: "Executive MBA" },
  { value: "IMTECH", label: "Integrated M.Tech." },
  { value: "MSCBR", label: "Master of Science By Research" },
  { value: "TYMSC", label: "Two Year M.Sc." },
  { value: "FYIMSC", label: "Five Year Integrated M.Sc." },
  { value: "DIIT", label: "D.I.I.T." },
  { value: "DIITEx", label: "D.I.T.T. (Exit Degree)" },
];

export const branchOptions = [
  { value: "Aerospace Engineering", label: "Aerospace Engineering" },
  { value: "Animation", label: "Animation" },
  { value: "Application Software Centre", label: "Application Software Centre" },
  { value: "Applied Geophysics", label: "Applied Geophysics" },
  { value: "Applied Statistics and Informatics", label: "Applied Statistics and Informatics" },
  { value: "Biomedical Engineering", label: "Biomedical Engineering" },
  { value: "Biosciences and Bioengineering", label: "Biosciences and Bioengineering" },
  { value: "Biotechnology", label: "Biotechnology" },
  { value: "Centre for Aerospace Systems Design and Engineering", label: "Centre for Aerospace Systems Design and Engineering" },
  { value: "Centre for Distance Engineering Education Programme", label: "Centre for Distance Engineering Education Programme"},
  { value: "Centre for Environmental Science and Engineering", label: "Centre for Environmental Science and Engineering" },
  { value: "Centre for Formal Design and Verification of Software", label: "Centre for Formal Design and Verification of Software" },
  { value: "Centre for Research in Nanotechnology and Science", label: "Centre for Research in Nanotechnology and Science" },
  { value: "Centre for Technology Alternatives for Rural Areas", label: "Centre for Technology Alternatives for Rural Areas" },
  { value: "Centre for Urban Science and Engineering", label: "Centre for Urban Science and Engineering" },
  { value: "Centre of Studies in Resources Engineering", label: "Centre of Studies in Resources Engineering" },
  { value: "Chemical Engineering", label: "Chemical Engineering" },
  { value: "Chemistry", label: "Chemistry" },
  { value: "Civil Engineering", label: "Civil Engineering" },
  { value: "Climate Studies", label: "Climate Studies" },
  { value: "Computer Centre", label: "Computer Centre" },
  { value: "Computer Science & Engineering", label: "Computer Science & Engineering" },
  { value: "Continuing Education Programme", label: "Continuing Education Programme" },
  { value: "Corrosion Science and Engineering", label: "Corrosion Science and Engineering" },
  { value: "Desai Sethi Centre for Entrepreneurship", label: "Desai Sethi Centre for Entrepreneurship" },
  { value: "Earth Sciences", label: "Earth Sciences" },
  { value: "Educational Technology", label: "Educational Technology" },
  { value: "Electrical Engineering", label: "Electrical Engineering" },
  { value: "Energy Science and Engineering", label: "Energy Science and Engineering" },
  { value: "Economics (HSS)", label: "Economics (HSS)" },
  { value: "Engineering Physics", label: "Engineering Physics" },
  { value: "Humanities & Social Science", label: "Humanities & Social Science" },
  { value: "IITB-Monash Research Academy", label: "IITB-Monash Research Academy" },
  { value: "Industrial Design Centre", label: "Industrial Design Centre" },
  { value: "Industrial Engineering and Operations Research", label: "Industrial Engineering and Operations Research" },
  { value: "Industrial Management", label: "Industrial Management" },
  { value: "Interaction Design", label: "Interaction Design" },
  { value: "Kanwal Rekhi School of Information Technology", label: "Kanwal Rekhi School of Information Technology" },
  { value: "Material Science", label: "Material Science" },
  { value: "Materials, Manufacturing and Modelling", label: "Materials, Manufacturing and Modelling" },
  { value: "Mathematics", label: "Mathematics" },
  { value: "Mechanical Engineering", label: "Mechanical Engineering" },
  { value: "Metallurgical Engineering & Materials Science", label: "Metallurgical Engineering & Materials Science" },
  { value: "Mobility and Vehicle Design", label: "Mobility and Vehicle Design" },
  { value: "National Centre for Aerospace Innovation and Research", label: "National Centre for Aerospace Innovation and Research" },
  { value: "National Centre for Mathematics", label: "National Centre for Mathematics" },
  { value: "Physical Education", label: "Physical Education" },
  { value: "Physics", label: "Physics" },
  { value: "Physics, Material Science", label: "Physics, Material Science" },
  { value: "Preparatory Course", label: "Preparatory Course" },
  { value: "Reliability Engineering", label: "Reliability Engineering" },
  { value: "Shailesh J. Mehta School of Management", label: "Shailesh J. Mehta School of Management" },
  { value: "Sophisticated Analytical Instrument Facility", label: "Sophisticated Analytical Instrument Facility" },
  { value: "Systems and Control Engineering", label: "Systems and Control Engineering" },
  { value: "Tata Center for Technology and Design", label: "Tata Center for Technology and Design" },
  { value: "Technology and Development", label: "Technology and Development" },
  { value: "Visual Communication", label: "Visual Communication" },
  { value: "Wadhwani Research Centre for Bioengineering", label: "Wadhwani Research Centre for Bioengineering" },
  { value: "Centre for Policy Studies", label: "Centre for Policy Studies" },
];
